import { useCallback, useContext, useState } from 'react';
import { notification } from 'antd';
import { useCreateaddendumMutation } from '@/state/slices/reports';
import { SettingsContext } from '@/state/contexts';

interface UseAddendumActionsParams {
  studyUuid: string | undefined;
}

export function useAddendumActions({ studyUuid }: UseAddendumActionsParams) {
  const [addendumVisible, setAddendumVisible] = useState(false);
  const [createaddendum, { isLoading: isCreating }] =
    useCreateaddendumMutation();
  const [api, contextHolder] = notification.useNotification();
  const { settings } = useContext(SettingsContext);

  const handleCreateAddendum = useCallback(
    async (payload: { reason: string; text: string }) => {
      try {
        await createaddendum({
          description: payload.text,
          reason: payload.reason,
          studyUuid: studyUuid || '',
        }).unwrap();

        api.success({
          message: 'Addendum created',
          description: 'Report addendum created successfully',
        });
      } catch (e: any) {
        api.error({
          message: 'Error creating addendum',
          description: e?.data?.detail || String(e),
        });
      } finally {
        setAddendumVisible(false);
      }
    },
    [createaddendum, studyUuid, api]
  );

  const openAddendum = useCallback(() => {
    if (settings.showAddendumModal) {
      setAddendumVisible(true);
      return;
    }

    handleCreateAddendum({
      reason: 'CONCURRENCE',
      text: '',
    }).catch(() => undefined);
  }, [handleCreateAddendum, settings.showAddendumModal]);

  return {
    addendumVisible,
    setAddendumVisible,
    openAddendum,
    handleCreateAddendum,
    isCreating,
    addendumNotificationHolder: contextHolder,
  };
}
